<template>
  <Modal
    :title="edit ? $t('departments.edit') : $t('departments.add')"
    @ok="(l) => (this.edit ? update(l) : save(l))"
    :value="value"
    :okText="edit ? $t('departments.edit') : $t('departments.add')"
    @input="$emit('input', $event)"
  >
    <PageTitle
      :description="
        edit
          ? $t('departments.editDescription')
          : $t('departments.addDescription')
      "
    ></PageTitle>
    <BaseInput
      class="u-margin-top-small"
      block
      input-id="title"
      :label="$t('departments.name')"
      size="sm"
      :placeholder="$t('departments.namePlaceholder')"
      v-model="title"
      :icon="'architecture'"
      :mandotary="validActivated"
    ></BaseInput>
    <div class="c-form-control c-form-control__variant--sm">
      <label for="" class="c-form-control__label u-margin-top-small">
        {{ $t("departments.description") }}
      </label>
      <textarea
        class="c-form-control c-form-control__textarea u-width-100%"
        block
        input-id="description"
        rows="3"
        :label="$t('departments.description')"
        size="sm"
        :placeholder="$t('departments.descriptionPlaceholder')"
        v-model="description"
      ></textarea>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Base/Modal.vue";
import PageTitle from "@/components/Shared/PageTitle/index.vue";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Requests from "@/services/Requests";
export default {
  components: {
    Modal,
    PageTitle,
    BaseInput,
  },
  props: {
    value: {
      default: false,
    },
    edit: {
      default: false,
      type: Boolean,
    },
    form: {
      default: () => ({
        id: null,
        title: "",
        description: "",
      }),
    },
  },
  data() {
    return {
      title: "",
      description: "",
      validActivated: false,
    };
  },
  watch: {
    title(value) {
      this.validActivated = value ? true : false;
    },
    value(value) {
      console.log(value, "valü");
      if (value) {
        this.checkProps();
      }
    },
  },

  methods: {
    async save(loading) {
      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.Department.Create({
        title: this.title,
        description: this.description,
        isActive: true,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("departments.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async update(loading) {
      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.Department.Update(
        {
          title: this.title,
          description: this.description,
        },
        { params: { id: this.form.id } }
      );
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("departments.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    validation() {
      if (this.title) {
        return true;
      }
      return false;
    },
    async checkProps() {
      if (this.edit) {
        this.title = this.form.title;
        this.description = this.form.description;
      }
    },
  },
  mounted() {
    this.checkProps();
  },
};
</script>

<style></style>
